import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Text,
  Select,
  Heading,
  Button,
  Stack,
  Link,
  HStack,
  Avatar,
  FormControl,
  FormLabel,
  SimpleGrid,
  Card,
  Checkbox,
  CardBody,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import axios from "axios";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Promotion = () => {
  const userId = sessionStorage.getItem("user_id");
  const schoolId = sessionStorage.getItem("school_id");
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [students, setStudents] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [classDetails, setClassDetails] = useState([]);

  const [promoteClasses, setPromoteClasses] = useState([]);
  const [promoteDivisions, setPromoteDivisions] = useState([]);
  const [promoteClass, setPromoteClass] = useState("");
  const [promoteDivision, setPromoteDivision] = useState("");
  // Fetch classes for both left and right sections
  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/class_master.php`
        );
        setClasses(response.data.data || []);
        setPromoteClasses(response.data.data || []);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };
    fetchClasses();
  }, []);

  // Fetch divisions when a class is selected (Left side)
  useEffect(() => {
    const fetchDivisions = async () => {
      if (!selectedClass) return;
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/division.php`,
          { params: { class_id: selectedClass } }
        );
        setDivisions(response.data.data || []);
      } catch (error) {
        console.error("Error fetching divisions:", error);
      }
    };
    fetchDivisions();
  }, [selectedClass]);

  useEffect(() => {
    const fetchClassDetails = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/list_all_class.php?school_id=${schoolId}`
        );
        setClassDetails(response.data.data || []);
      } catch (error) {
        console.error("Error fetching class details:", error);
      }
    };
    fetchClassDetails();
  }, []);

  // Fetch divisions for promoted class (Right side)
  useEffect(() => {
    const fetchPromoteDivisions = async () => {
      if (!promoteClass) return;
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/division.php`,
          { params: { class_id: promoteClass } }
        );
        setPromoteDivisions(response.data.data || []);
      } catch (error) {
        console.error("Error fetching promote divisions:", error);
      }
    };
    fetchPromoteDivisions();
  }, [promoteClass]);

  // Fetch students when both class & division are selected
  useEffect(() => {
    const fetchStudents = async () => {
      if (!selectedClass || !selectedDivision) return;
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/promotion/display_students.php`,
          {
            params: {
              class_id: selectedClass,
              division_id: selectedDivision,
              school_id: sessionStorage.getItem("school_id"), // Change as needed
            },
          }
        );
        const fetchedStudents = response.data.data.students || [];
        setStudents(fetchedStudents);
        setSelectedStudents(fetchedStudents.map((student) => student.id));
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    };
    fetchStudents();
  }, [selectedClass, selectedDivision]);

  // Handle student selection
  const handleStudentSelect = (studentId) => {
    setSelectedStudents((prev) =>
      prev.includes(studentId)
        ? prev.filter((id) => id !== studentId)
        : [...prev, studentId]
    );
  };
  const handlePromotion = async () => {
    const classDetail = classDetails.find(
      (cd) => cd.class_id === promoteClass && cd.division_id === promoteDivision
    );
    console.log("---class deteailes--", classDetail);
    if (!classDetail) {
      alert("No matching class details found.");
      return;
    }

    const classDetailsId = classDetail.id;

    try {
      const response = await axios.put(
        `${BASE_URL}/admin/promotion/promote_students.php`,
        {
          user_id: userId,
          school_id: schoolId,
          student_ids: selectedStudents,
          class_details_id: classDetailsId,
          promoted_from: selectedClass,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("Response of promotion:", response);
      alert( response.data); // Log actual response data
    } catch (error) {
      console.error("Error promoting students:", error);
    }
  };

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Promotion</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            {/* <Button colorScheme="teal"></Button> */}
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Promotion</span>
        </Box>
      </div>

      <Box maxWidth="100%" p={7} mt={5}>
        <Text color="gray.600" mb={8}>
          Select a Class and Section to Promote to the next session.
        </Text>

        <Grid templateColumns={{ base: "1fr", md: "1fr 80px 1fr" }} gap={6}>
          {/* Left Section */}
          <GridItem>
            <Stack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Current Session</FormLabel>
                <Select placeholder="2024 - 2025" isDisabled>
                  <option value="2024-2025">2024 - 2025</option>
                </Select>
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Promote from Class</FormLabel>
                <Grid templateColumns="1fr 1fr" gap={4}>
                  <Select
                    placeholder="Select Class"
                    value={selectedClass}
                    onChange={(e) => setSelectedClass(e.target.value)}
                  >
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class}
                      </option>
                    ))}
                  </Select>
                  <Select
                    placeholder="Select Section"
                    value={selectedDivision}
                    onChange={(e) => setSelectedDivision(e.target.value)}
                    isDisabled={!selectedClass}
                  >
                    {divisions.map((div) => (
                      <option key={div.id} value={div.id}>
                        {div.division}
                      </option>
                    ))}
                  </Select>
                </Grid>
              </FormControl>
            </Stack>
          </GridItem>

          {/* Middle Section - Arrow Icon */}
          <GridItem display="flex" alignItems="center" justifyContent="center">
            <Box
              bg="teal.500"
              p={2}
              borderRadius="md"
              color="white"
              fontSize="xl"
            >
              →
            </Box>
          </GridItem>

          {/* Right Section */}
          <GridItem>
            <Stack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Promote to Session</FormLabel>
                <Select placeholder="2025 - 2026">
                  <option value="2025-2026">2025 - 2026</option>
                </Select>
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Promote to Class</FormLabel>
                <Grid templateColumns="1fr 1fr" gap={4}>
                  <Select
                    placeholder="Select Class"
                    value={promoteClass}
                    onChange={(e) => setPromoteClass(e.target.value)}
                  >
                    {promoteClasses.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class}
                      </option>
                    ))}
                  </Select>
                  <Select
                    placeholder="Select Section"
                    value={promoteDivision}
                    onChange={(e) => setPromoteDivision(e.target.value)}
                    isDisabled={!promoteClass}
                  >
                    {promoteDivisions.map((div) => (
                      <option key={div.id} value={div.id}>
                        {div.division}
                      </option>
                    ))}
                  </Select>
                </Grid>
              </FormControl>
            </Stack>
          </GridItem>
        </Grid>
        {/* Buttons */}
        <HStack spacing={4} mt={8} justify="flex-end">
          <Button
            colorScheme="teal"
            onClick={handlePromotion}
            isDisabled={selectedStudents.length === 0}
          >
            Promote Selected Students
          </Button>{" "}
        </HStack>
        <SimpleGrid columns={{ base: 1, md: 4 }} spacing={4} mt={2}>
          {students.map((student, index) => (
            <Card
              key={student.id}
              bg={["blue.100", "green.100", "yellow.100", "red.100"][index % 4]}
              p={1}
              borderRadius="md"
              _hover={{
                transform: "scale(1.05)",
                transition: "0.2s ease-in-out",
              }}
            >
              <CardBody
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Stack direction="row" align="center">
                  <Avatar name={student.name} size="sm" />
                  <Box fontWeight="semi-bold">{student.name}</Box>
                </Stack>
                <Checkbox
                  icon={<CheckCircleIcon />}
                  isChecked={selectedStudents.includes(student.id)}
                  onChange={() => handleStudentSelect(student.id)}
                />
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      </Box>
    </div>
  );
};

export default Promotion;
